/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const SupportoPage = lazy(() => import('./pages/list/SupportoPage'))
const SupportTicketDetailPage = lazy(() => import('./pages/details/SupportTicketDetailPage'))

export const supportoRoutes: RouteObject[] = [
  {
    path: 'supporto',
    element: <SupportoPage />,
  },
  {
    path: 'supporto/aziende/:ticketId',
    element: <SupportTicketDetailPage />,
  },
  {
    path: 'supporto/utenti/:ticketId',
    element: <SupportTicketDetailPage />,
  },
]